var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary",class:{'is-invalid': !_vm.isValid}},[(_vm.isValid && !_vm.is.updating)?[_vm._v(" "+_vm._s(_vm.summary)+" ")]:_vm._e(),(_vm.isValid && _vm.is.updating)?_c('i',{staticClass:"fa-solid fa-spinner fa-spin summary-loading"}):_vm._e(),(!_vm.isValid)?[_vm._v(" Enter the required values. ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }